<template>
	<div data-tour-scope="setting-stats">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>{{ this.$vuetify.lang.t('$vuetify.front.subsetting.stats') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>

						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni servizio diventa una card, la configurazione si apre dentro la card -->
								<tbody v-if="mobileCards" class="setstats-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<div v-if="s.video" class="st-video">
														<div class="st-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per ottenere le API Key da inserire in Az Seller
														</div>
														<youtube :video-id="videomap" player-width="100%"></youtube>
													</div>
													<v-alert v-if="s.key === 'clarity'" outlined text dense type="info" class="text-body-2 mb-3">
														Mappe di calore e registrazioni delle visite del sito, da guardare su <b>clarity.microsoft.com</b>. Lo script di Clarity si incolla a mano nella testata del sito.
														<ol class="mt-2 mb-0">
															<li>Su <b>clarity.microsoft.com</b> crea un progetto per il sito (gratuito) e copia l’ID del progetto qui sotto: serve alla verifica e ai numeri nel gestionale.</li>
															<li>Copia il codice qui sotto e incollalo in <b>Sito ecommerce → Impostazioni Tema → Script e azioni → Header</b>.</li>
															<li>
																Se il sito ha un banner cookie, fai partire lo script solo dopo il consenso alle statistiche, come il banner chiede per gli altri script (iubenda, Cookiebot,
																CookieYes...).
															</li>
															<li>Eventi (aggiunta al carrello, checkout, acquisto, registrazione, newsletter) e mascheramento di checkout, profilo e accesso li aggiunge Azseller.</li>
															<li>
																Per vedere i numeri in <b>Statistiche → Comportamento</b>: su Clarity apri <b>Impostazioni &gt; Esportazione dati</b>, genera un token API e incollalo qui. Se un token
																è già salvato il campo resta vuoto: scrivi solo per cambiarlo.
															</li>
														</ol>
														<div v-if="codiceClarity" class="mt-2">
															<pre class="st-code">{{ codiceClarity }}</pre>
															<v-btn x-small outlined color="primary" class="mt-1" @click="copiaClarity"><v-icon left x-small>mdi-content-copy</v-icon>Copia il codice</v-btn>
														</div>
													</v-alert>
													<div v-if="s.credenziali" class="mb-3">
														<v-file-input
															v-model="file"
															label="File JSON con le credenziali di Google"
															accept=".json"
															show-size
															dense
															outlined
															hide-details
															background-color="white"
															@change="handleFileUpload"
														></v-file-input>
														<a v-if="googleAnalytics.setting.apikey" :href="googleAnalytics.setting.apikey" target="_blank" class="st-small">File JSON caricato</a>
													</div>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"
															><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn
														>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :data-tour="s.indice === 0 ? 'settings' : null" @save="saveSetting(s.indice)">
													<div v-if="s.video" class="st-video">
														<div class="st-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per ottenere le API Key da inserire in Az Seller
														</div>
														<youtube :video-id="videomap" player-width="100%"></youtube>
													</div>
													<v-alert v-if="s.key === 'clarity'" outlined text dense type="info" class="text-body-2 mb-3">
														Mappe di calore e registrazioni delle visite del sito, da guardare su <b>clarity.microsoft.com</b>. Lo script di Clarity si incolla a mano nella testata del sito.
														<ol class="mt-2 mb-0">
															<li>Su <b>clarity.microsoft.com</b> crea un progetto per il sito (gratuito) e copia l’ID del progetto qui sotto: serve alla verifica e ai numeri nel gestionale.</li>
															<li>Copia il codice qui sotto e incollalo in <b>Sito ecommerce → Impostazioni Tema → Script e azioni → Header</b>.</li>
															<li>
																Se il sito ha un banner cookie, fai partire lo script solo dopo il consenso alle statistiche, come il banner chiede per gli altri script (iubenda, Cookiebot,
																CookieYes...).
															</li>
															<li>Eventi (aggiunta al carrello, checkout, acquisto, registrazione, newsletter) e mascheramento di checkout, profilo e accesso li aggiunge Azseller.</li>
															<li>
																Per vedere i numeri in <b>Statistiche → Comportamento</b>: su Clarity apri <b>Impostazioni &gt; Esportazione dati</b>, genera un token API e incollalo qui. Se un token
																è già salvato il campo resta vuoto: scrivi solo per cambiarlo.
															</li>
														</ol>
														<div v-if="codiceClarity" class="mt-2">
															<pre class="st-code">{{ codiceClarity }}</pre>
															<v-btn x-small outlined color="primary" class="mt-1" @click="copiaClarity"><v-icon left x-small>mdi-content-copy</v-icon>Copia il codice</v-btn>
														</div>
													</v-alert>
													<div v-if="s.credenziali" class="mb-3">
														<v-file-input
															v-model="file"
															label="File JSON con le credenziali di Google"
															accept=".json"
															show-size
															dense
															outlined
															hide-details
															background-color="white"
															@change="handleFileUpload"
														></v-file-input>
														<a v-if="googleAnalytics.setting.apikey" :href="googleAnalytics.setting.apikey" target="_blank" class="st-small">File JSON caricato</a>
													</div>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"
															><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn
														>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { uuid } from 'vue-uuid';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from '@/views/setting/components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createStatsSettingsTourSteps, stopStatsSettingsTour } from './stats-settings-tour';

export default {
	name: 'Stats',
	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	setup() {
		return { tour: useTour(createStatsSettingsTourSteps(), { onStop: stopStatsSettingsTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			videomap: 'o3xd5DZOllA',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			file: null,
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'googleMap' },
			headers: [
				{ text: '', sortable: false },
				{ text: 'Servizio', sortable: false },
				{ text: 'Status', sortable: false },
			],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			googleMap: {
				active: false,
				setting: {
					apikey: '',
					placeId: '',
				},
				type: 'stats',
				service: 'googleMap',
			},
			googleAnalytics: {
				active: false,
				setting: {
					apikey: '',
					propertyId: '',
				},
				type: 'stats',
				service: 'googleAnalytics',
			},
			// Microsoft Clarity: mappe di calore e registrazioni, script caricato dal sito pubblico dopo il consenso
			clarity: {
				active: false,
				setting: {
					projectId: '',
				},
				type: 'stats',
				service: 'clarity',
			},

			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 0,
					key: 'googleMap',
					connessione: 'googleMap',
					nome: 'Google map',
					logo: require('@/assets/images/grafici/maps.svg'),
					video: true,
					campi: [
						{ key: 'apikey', label: 'API Key', tipo: 'password' },
						{ key: 'placeId', label: 'Place Id' },
					],
				},
				{
					indice: 1,
					key: 'googleAnalytics',
					connessione: 'googleAnalytics',
					nome: 'Google analytics',
					logo: require('@/assets/images/google-analytics.svg'),
					credenziali: true,
					campi: [{ key: 'propertyId', label: 'Property Id' }],
				},
				{
					indice: 2,
					key: 'clarity',
					connessione: 'clarity',
					nome: 'Microsoft Clarity',
					logo: require('@/assets/images/microsoft-clarity.svg'),
					campi: [
						{ key: 'projectId', label: 'ID progetto Clarity' },
						// cifrato sul server: dal BO arriva vuoto, vuoto = resta quello salvato
						{ key: 'apiToken', label: 'Token API di Clarity (per i numeri in Statistiche → Comportamento)', tipo: 'password' },
					],
				},
			],
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['googleMap', 'googleAnalytics', 'clarity']));
		await Promise.all(promises);

		this.setPreload(false);

		let googleMap = _.find(this.getServices, set => {
			return set.service === 'googleMap';
		});
		if (googleMap) {
			this.googleMap = googleMap;
		}
		let googleAnalytics = _.find(this.getServices, set => {
			return set.service === 'googleAnalytics';
		});
		if (googleAnalytics) {
			this.googleAnalytics = googleAnalytics;
		}
		const clarity = _.find(this.getServices, { service: 'clarity' });
		if (clarity) {
			this.clarity = { ...clarity, setting: { projectId: '', ...(clarity.setting || {}) } };
		}
	},

	computed: {
		// script ufficiale di Clarity con l'ID del progetto, da incollare nella testata del sito
		codiceClarity() {
			const id = String((this.clarity.setting && this.clarity.setting.projectId) || '').trim();
			if (!/^[a-z0-9]{8,14}$/i.test(id)) return '';
			return (
				`<script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${id}");
</` + `script>`
			);
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		async handleFileUpload(file) {
			if (file && file.name) {
				const formData = new FormData();
				formData.append('file', file, file.name);
				formData.append('uuid', uuid.v4());

				const response = await axios.post(`${this.getUrl}multimedias/uploadfile`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data', // Imposta il tipo di contenuto
						Authorization: `Bearer ${this.getToken}`,
					},
				});

				this.googleAnalytics.setting.apikey = response.data.url;
				this.$forceUpdate();
				//payload.value['sitemaps'].push(image);
			}
			/*if (this.amazonpay.setting?.pem) {
        console.log('File caricato:', this.amazonpay.setting.pem);
      }*/
		},
		saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.googleMap;
					this.setPreload(true);
					break;
				case 1:
					payload = this.googleAnalytics;
					this.setPreload(true);
					break;
				case 2:
					// l'ID si salva pulito: serve al codice da copiare, alla verifica e ai link verso Clarity
					this.clarity.setting.projectId = String(this.clarity.setting.projectId || '').trim();
					payload = this.clarity;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del servizio: created() lo sostituisce, quindi va letto ogni volta
		async copiaClarity() {
			try {
				await navigator.clipboard.writeText(this.codiceClarity);
				this.snackbar = { ...this.snackbar, color: 'success', text: 'Codice copiato: incollalo in Impostazioni Tema → Script e azioni → Header', snackbar: true, timeout: 5000 };
			} catch (e) {
				this.snackbar = { ...this.snackbar, color: 'error', text: 'Copia non riuscita: seleziona il codice e copialo a mano', snackbar: true, timeout: 5000 };
			}
		},
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* video e credenziali in cima al riquadro */
.st-video {
	max-width: 560px;
	margin-bottom: 16px;
}
.st-video-caption {
	display: flex;
	align-items: center;
	font-size: 13px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.st-small {
	font-size: 13px;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.setstats-cards,
.setstats-cards tr {
	display: block;
	width: 100%;
}
.setstats-cards tr,
.setstats-cards tr:hover {
	background: transparent !important;
}
.setstats-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.setstats-cards tr:first-child td {
	padding-top: 12px !important;
}
.setstats-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.setstats-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
/* codice di Clarity da copiare */
.st-code {
	background: #fff;
	border: 1px solid #d6dde6;
	border-radius: 6px;
	padding: 8px;
	font-size: 12px;
	white-space: pre-wrap;
	word-break: break-all;
	color: #1f2933;
}
</style>
